import { createSelector } from 'reselect';
import { civilRewardsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const civilRewardsYearsSelector = createSelector([civilRewardsSelector], (civilRewards) =>
  extractDatesFromNestedItems(
    [civilRewards.content],
    [
      {
        type: 'date',
        field: 'date',
      },
    ],
  ),
);
